import { NavItem } from '../types/navigation.types';

export const navigationConfig: NavItem[] = [
    { label: 'Home', path: '/' },
    { label: 'CV', path: '/cv' },
    { label: 'Projects', path: '/projects' },
    { label: 'Flying', path: '/flying' },
]; 